<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{$t('ordine_storico')}}</h1></div>
            <div class="content content-full">
                <div class="title">{{$t('ordini_effettuati')}}</div>
                <div class="container">
                    <div class="row row-sezione">
                        <div class="col-12">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
                            </router-link>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="container">
                    <div class="row-sezione">
                        <div v-if="this.orders.length">
                            <div class="blocchetto" style="margin-bottom: 0;"
                                 v-for="order in this.orders">
                                {{$t('carrello_ordine_label').capitalize()}} n°: {{order.id}} -
                                <inc-order-status :status="order.status"/>
                                <br>
                                <b>
                                    <inc-order-type :type="order.tipo_ordine"/>
                                    -
                                    <inc-order-datetime :datetime-delivery-takeaway="order.data_ora_consegna_ritiro"
                                                        :delivery-takeaway-end-slot="order.consegna_ritiro_fine_fascia"
                                                        :language="language"/>
                                </b><br>
                                <div v-if="order.tipo_racer === 'GLOVO'">
                                    <img height="20" src="/img/be/glovo-status.png" alt="glovo"/>
                                    <span class="ml-1">{{ getGlovoStatus(order.status_spedizione) }}</span>

                                    <div v-if="order.nominativo_corriere_spedizione || order.telefono_corriere_spedizione">
                                        <span>{{ getGlovoCourier(order.nominativo_corriere_spedizione, order.telefono_corriere_spedizione) }}</span>
                                    </div>
                                </div>
                                {{$t('ordini_pagamento')}}:
                                <inc-order-payment-mode :payment-mode="order.modalita_pagamento"/>
                                <br>
                                <span class="color">
                                    <b>{{$t('totale')}}:  {{order.totale_ordine.toFixedGood(2)}} {{locale_currency}}</b>
                                </span>

                                <div class="blocchetto-right">
                                    <a href="#" @click.prevent="openMessagingModal(order)"
                                       class="a1 link-modal-messaggeria" v-if="order.tipo_ordine !== 'ORDINA_TAVOLO' && !!order.chat_visible">
                                        <i class="fas fa-paper-plane mr-1"></i>{{$t("messaggeria")}}
                                        <span class="badge badge-info" v-if="getConversationMsgCounter(order)">
                                            {{getConversationMsgCounter(order)}}</span>
                                    </a>
                                    <br>
                                    <router-link :to="{name:'orders.details', params:{id:order.id}}" class="a1">
                                        <i class="fa fa-eye"></i> {{$t('dettagli')}}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <p class="text-center f4" style="margin-top: 30px;" v-else>
                            <i>{{$t('nessun_ordine')}}</i>
                        </p>
                    </div>
                </div>
                <hr>
                <div class="container">
                    <div class="row row-sezione">
                        <div class="col-12">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-messaging v-if="this.show_modal" @close="show_modal = false"
                         type="ORDINE"
                         :item="this.selected_order"
        />
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {getOrderHistory} from '../../api/account';
import { getGlovoStatus, getGlovoCourier } from "../../libraries/utils";

import IncOrderType from "./partials/IncOrderType";
import IncOrderDatetime from "./partials/IncOrderDatetime";
import IncOrderStatus from "./partials/IncOrderStatus";
import IncOrderPaymentMode from "./partials/IncOrderPaymentMode";
import ModalMessaging from "../messaging/partials/ModalMessaging";

export default {
    name: "History",
    components: {ModalMessaging, IncOrderPaymentMode, IncOrderStatus, IncOrderDatetime, IncOrderType},
    data() {
        return {
            orders: [],

            show_modal: false,
            selected_order: null
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency'
        }),
        ...mapGetters('chat', {
            getMsgCounterFromId: 'getMsgCounterFromId'
        })
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getOrderHistory(this.language, {
                id_ristorante: this.id_ristorante,
                api_key: this.user.api_key,
                counter_messaggi: false
            }).then((response) => {
                this.orders = response.ordini;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        openMessagingModal: function (order) {
            this.selected_order = order;
            this.show_modal = true;
        },
        getConversationMsgCounter: function (order) {
            try {
                return this.getMsgCounterFromId(order.chat.id);
            } catch (e) {
                return null
            }
        },
        getGlovoStatus,
        getGlovoCourier,
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
